export const reportSalesCategoryTypes = {
  SET_REPORT_SALES_CATEGORY_FILTERS: 'SET_REPORT_SALES_CATEGORY_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL'
};